// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-L":"L_dpu-detail-L__tT85T"};